import { Button } from "@mui/material"
import { useState } from "react"
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked"
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked"
import { useDispatch } from "react-redux"
import { setSchema, setTable } from "../../../redux/slices/toggleControlSlices"


export default function TableButton({ table, index, tableName, schemaName, schema }) {
    const dispatch = useDispatch()
    const [hovered, setHovered] = useState(false)

    return(
        <Button
            key={index}
            startIcon={
                tableName === table.table_name && schemaName === schema ? (
                    <RadioButtonCheckedIcon sx={{ color: "#118EA0" }} />
                ) : (
                    <RadioButtonUncheckedIcon />
                )
            }
            onClick={() => {
                if (tableName !== table.table_name || schemaName !== schema) {
                    dispatch(setTable(table.table_name))
                    dispatch(setSchema(schema))
                } else {
                    dispatch(setTable(""))
                    dispatch(setSchema(""))
                }
            }}
            sx={{
                color: hovered ? "#118EA0" : "#fff",
                backgroundColor: "transparent !important",
                textTransform: "none",
                maxHeight: "32px",
                minHeight: "32px",
                justifyContent: "left",
                fontFamily: "Averta"
            }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            {table.table_name}
        </Button>
    )
}